<mat-toolbar style="padding: 0px;">
  <button mat-icon-button (click)="toggleSidenav()">
    <mat-icon >menu</mat-icon>
  </button>
  <div [ngStyle]="{'color': backColor}">
    <ng-content select="[title]"></ng-content> 
  </div>
  <span class="example-spacer"></span>
  <ng-content select="[headeractions]"></ng-content>
  <button mat-icon-button (click)="goBack()" >
    <mat-icon>navigate_before</mat-icon>
  </button>
  <button mat-icon-button [matMenuTriggerFor]="menu" >
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <ng-content select="[menuactions]"></ng-content>
    <!-- <button mat-menu-item (click)="goBack()" >
      <mat-icon>arrow_back</mat-icon>
      go back
    </button> -->
    <button *ngIf="isLoggedIn===false" mat-menu-item (click)="goToLogin()" >
      <mat-icon>login</mat-icon>
      Login
    </button>
    <button *ngIf="isLoggedIn===true" mat-menu-item (click)="goToLogin()" >
      <mat-icon>logout</mat-icon>
      Logout
    </button>
    <button mat-menu-item (click)="goToUserEdit()">
      <mat-icon>account_circle</mat-icon>
      Profile
    </button>
  </mat-menu>
</mat-toolbar>

<!-- <mat-card appearance="outlined">
</mat-card> -->


